import React from "react";
import moment from "moment";
import { QueryInterestProfile_interest as Interest } from "types/gql-types";
import Copyable from "components/copyable";
import styles from "../details.module.css";

import Heading from "./heading";
import Row from "./row";

type Props = { interest: Interest }
const Overview: React.FC<Props> = ({ interest }) => (
  <div className={styles.group}>
    <Heading text="Overview" />
    <Row title="Length of Wait">
      {interest.submittedAt &&
        moment(new Date(interest.submittedAt * 1000))
          .fromNow()
          .replace("ago", "")}
    </Row>
    <Row title="Last Updated">
      {interest.updatedAt && moment(`${interest.updatedAt}Z`).local().format("M/D/YY")}
    </Row>
    <Row title="Applied">
      {interest.submittedAt && moment(new Date(interest.submittedAt * 1000)).format("M/D/YY")}
    </Row>
    <Row title="Haven Connect Account?">{interest.userId ? "Yes" : "No"}</Row>
    {!!interest.linkCode && <Row title="Paper App Link Code">{interest.linkCode}</Row>}
    {interest.updateRequest?.isActive && (
      <Row title="Update URL">
        <Copyable text={interest.updateRequest.updateUrl} />
      </Row>
    )}
  </div>);

export default Overview;
